module.exports = __webpack_public_path__ + "static/media/communicate-and-connect.4eed5e66.png";